import { useEffect, useState } from "react";

const CountUp = ({ target, start }: { target: string; start: boolean }) => {
  const [count, setCount] = useState(0);

  const numericValue = parseFloat(target.replace(/,/g, ''));
  const suffix = target.replace(/[0-9.,]/g, '');
  const hasDecimal = target.includes('.');
  const decimals = hasDecimal ? target.split('.')[1].replace(/[^0-9]/g, '').length : 0;

  useEffect(() => {
    if (!start) return;

    let startTime: number | null = null;
    const duration = 2000;

    const animate = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;

      const percentage = Math.min(progress / duration, 1);
      const easeOut = percentage === 1 ? 1 : 1 - Math.pow(2, -10 * percentage);

      const currentVal = numericValue * easeOut;

      setCount(currentVal);

      if (progress < duration) {
        requestAnimationFrame(animate);
      } else {
        setCount(numericValue);
      }
    };

    requestAnimationFrame(animate);
  }, [start, numericValue]);

  const formattedCount = count.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

  return <span>{formattedCount}{suffix}</span>;
};

export default CountUp;